import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddFeeToAllComp from "./Component/AddFeeToAllComp"


const AddFeeToAll =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddFeeToAllComp />
        </div>
        <Footer />
        </>
    )
}

export default AddFeeToAll